<template lang="html">
  <section>
    <!-- <div v-if="tools" class="overlay" :class="{unhide: tools}"></div> -->

    <div class="nav">
        <div class="nav__child" @click="$router.push('/')">view site</div>
        <div :class="{'active-nav' : $route.path.includes('settings')}" class="nav__child" @click="$router.push('/admin/settings')">site settings</div>
        <div :class="{'active-nav' : $route.path.includes('media')}" class="nav__child" @click="$router.push('/admin/media')">media</div>
        <div :class="{'active-nav' : $route.path.includes('pages')}" class="nav__child" @click="$router.push('/admin/pages')">pages</div>
        <div :class="{'active-nav' : $route.path.includes('blocks')}" class="nav__child" @click="$router.push('/admin/blocks')">blocks</div>
        <div :class="{'active-nav' : $route.path.includes('users')}" class="nav__child" @click="$router.push('/admin/users')">users</div>
    </div>

    <div class="portal-align">
        <router-view></router-view>
    </div>
    <div @click="tools = !tools" class="tools">
      <div class="line"></div>
      <div class="line"></div>
      <div class="line"></div>

    </div>

      <div class="media" v-if="mediaBlock"> 
        <Media/>
      </div>
    </div>

  </section>

</template>

<script>
import { page } from 'vue-analytics'
import { firestore } from '../main'
import firebase from 'firebase'
import Media from './Media.vue'



export default {
  data () {
    return {
      media: {},
      mediaBlock: false,
      tools: false
      
    }
  },
  components: {
    Media
  },
    firestore() {
    return {
      media: firestore.collection("media")
    }
  },
  methods: {
    track () {
      page('/')
    }
  }
}
</script>

<style lang="scss">


$brandColor: #93923f;
$brandColorTwo: #aaaa65;

.tools {
  z-index: 5;
  background-color: $brandColor;
  color: #eee;
  width: 40px;
  height: 40px;
  position: absolute;
  bottom: 20px;
  right: 20px;
  border-radius: 25%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all .25s ease-in-out;
  &:hover {
    background-color: #aaaa65; 
    transform: scale(1.3);
    border-radius: 50%;
  }
    .line {
      background-color: #fff;
      height: 2px;
      width: 40%;
      margin: 2px 0;
    }
}

.media {
  position: fixed;
  top: 60px;
  right: 40px;
  bottom: 60px;
  left: 200px;
}

.nav {
    background-color: #222;
    color: #ddd;
    position: fixed;
    left: 0;
    top: 0;
    padding-top: 65px;
    width: 150px;
    height: 100%;
    display: flex;
    flex-direction: column;
    box-shadow: 5px 3px 10px #aaa;
    z-index: 2;
    &__child{
      margin: 0 auto;
      width: calc(100% - 20%);
      font-size: 16px;
      text-align: left;
      font-weight: 500;
      padding: 10px 10%;
      cursor: pointer;
      transition: all .15s ease-in-out;

      &:hover {
        background-color: #333;
      }
    }
    .active-nav {
      background-color: $brandColor;
      background-image: url('/static/arrow.svg');
      background-repeat: no-repeat;
      background-position: right;
      background-size: 20%;
    }
}

.portal-align {
    position: absolute;
    height: 100%;
    width: calc(100% - 150px);
    left: 150px;
    background-color: #ddd;
    padding: 2em 0;
    overflow-y: scroll;
}
.portal__options {
  position: absolute;
  right: 1em;
  top: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;

}

.portal {
  position: relative;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  // global
  ul {
    margin: 1em auto;
    padding: 1em 0;
    li {
      list-style: none;
      outline: #fff;
      
      img {
        pointer-events: none;
      }
    }
  }

  .full-width {
    width: 100%;
    text-align: left;
    padding: 10px 0;
  }

  .edit {
    background-color: #ddd;
    width: 100%;
    margin: 1em 0 0 0;
    padding: 0;
    height: auto
  }

  &__edit-child {
    background-color: #eee;
    width: 95%;
    height: auto;
    padding: 2em 0;
    margin: 2em auto;
  }

  .space-around-1 {
    margin: 0 1em;
  }

  &__tools {
    position: absolute;
    width: 100%;
    height: 65px;
    top: 0;
    left: 0;
    background-color: #d0d0d0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__tools-spacer{
    position: relative;
    height: 65px;
    width: 100%;
  }
  &__image-container {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: row;
    flex-flow: wrap;
  }


  &__image-parent {
      width: 12vw;
      height: 12vw;
      border: 1px solid #fff;
      padding: 2px;
      margin: 1px;
      display: flex;
      align-items: center;
      justify-content: center;
      // background-color: #ddd;
        img {
          max-width: 100%;
          max-height: 100%;
          height: auto;
        }
    }

  &__block {
    width: 90%;
    height: auto;
    padding: 1em;
    margin: 10px auto;
    position: relative;
    background-color: #eee;
    display: flex;
    flex-direction: row;
    flex-flow: wrap;
    align-items: center;
    border-left: 4px solid $brandColor;
    .icon {
      width: 30px;
      cursor: pointer;
    }
  }
    &__add {
    width: 90%;
    height: auto;
    padding: 8px 1em;
    margin: 10px auto;
    position: relative;
    background-color: $brandColor;
    display: flex;
    flex-direction: row;
    flex-flow: wrap;
    align-items: center;
    border-left: 4px solid $brandColorTwo;
    color: #fff;
    cursor: pointer;
    &:hover {
      background-color: $brandColorTwo;
      border-left: 4px solid $brandColor;
    }
    img {
      width: 30px;
      margin: 0 10px 0 0;
    }
    }
  &__logo {
    width: 50%;
    border: 1px solid #ddd;
    img {
      height: 80%;
      padding: 1em;
    }
  }
  &__button {
    padding: 5px 15px;
    background-color: $brandColor;
    color: #fff;
    cursor: pointer;
    font-size: 14px;
  }
  input {
    padding: 1em;
    outline: none;
    border: none;
    margin: 0 1em;
    font-size: 14px;
    background-color: #ddd;
    cursor: pointer;
    border-radius: 5px;
  }
}
// .overlay {
//   position: fixed;
//   width: 100%;
//   height: 100%;
//   background-color: #93913f81;
//   top: 0;
//   bottom: 0;
//   right: 0;
//   left: 0;
//   z-index: 3;
//   opacity: 0;
//   pointer-events: none;
//   transition: all 2s ease-in-out;
// }
.unhide {
  opacity: 1;
}

</style>



// WEBPACK FOOTER //
// src/components/Admin.vue